import { formatMarket } from "../_Shared/targetMarkets";

export function editionLabel(edition) {
  return formatMarket(edition.countryCode, edition.languageCode);
}

export function usableEditions(editions = []) {
  return editions.filter(
    (e) =>
      e.claimCount > 0 ||
      e.status === "Ready" ||
      e.status === "Sweeping" ||
      e.status === "Reading" ||
      e.status === "Synthesizing"
  );
}

export function clusterFromWorkstream(workstream, planId, planName) {
  const ideas = workstream.contentIdeas || [];
  return {
    id: workstream.id,
    title: workstream.title,
    goal: workstream.goal,
    hasResearchedDossier: workstream.hasResearchedDossier,
    editions: workstream.editions || [],
    ideaCount: ideas.length,
    publishedCount: ideas.filter((i) => i.status === "published").length,
    draftCount: ideas.filter((i) => i.status === "draftReadyForReview").length,
    generatingCount: ideas.filter((i) => i.status === "generating").length,
    ideaPendingCount: ideas.filter((i) => i.status === "idea").length,
    approvedCount: ideas.filter((i) => i.status === "approvedForGeneration")
      .length,
    planId,
    planName,
  };
}

export function clusterFromSummary(cluster, plan) {
  return {
    ...cluster,
    editions: cluster.editions || [],
    planId: plan.id,
    planName: plan.name,
    planStatus: plan.status,
  };
}

const RUNNING = ["Sweeping", "Reading", "Synthesizing"];

/** none | running | ready — ready means a dossier with claims, not merely a job in flight. */
export function clusterResearchStatus(cluster) {
  const editions = cluster.editions || [];
  if (
    cluster.hasResearchedDossier ||
    editions.some((e) => e.claimCount > 0 || e.status === "Ready")
  ) {
    return "ready";
  }
  if (editions.some((e) => RUNNING.includes(e.status))) {
    return "running";
  }
  return "none";
}

export function articleCountsLabel(cluster) {
  const total = cluster.ideaCount || 0;
  if (total === 0) return "No articles yet";
  const parts = [];
  if (cluster.publishedCount) {
    parts.push(`${cluster.publishedCount} published`);
  }
  if (cluster.draftCount) {
    parts.push(
      `${cluster.draftCount} draft${cluster.draftCount === 1 ? "" : "s"}`
    );
  }
  if (cluster.generatingCount) {
    parts.push(`${cluster.generatingCount} writing`);
  }
  if (parts.length === 0) {
    return `${total} article${total === 1 ? "" : "s"}`;
  }
  return parts.join(" · ");
}
